module.exports = __webpack_public_path__ + "images/emoji/fallen_leaf.4c1520ea0993f05b38b3.png";